import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { formatExchangeName } from '../../../../lineItemHelpers'

import { dv360TargetingSelector } from '../../../../../../modules/selectors/dv360Constants'

import { targetingTypes } from '../../../LineItemDv360Create/fields'

const ExchangesSectionPreview = () => {
  const targeting = useSelector(dv360TargetingSelector)

  const formattedExchangesNames = useMemo(() => {
    const exchanges = targeting.filter(item => item.type === targetingTypes.TARGETING_TYPE_EXCHANGE)
    return (
      exchanges
        // We show only exchanges that have a name
        .filter(exchange => exchange.exchange)
        .map(exchange => formatExchangeName(exchange.exchange))
    )
  }, [targeting])

  return (
    <>
      {formattedExchangesNames.map((exchange, index) => (
        <p key={index}>{exchange}</p>
      ))}
    </>
  )
}

export default ExchangesSectionPreview
